import React, { Component } from 'react';
import { connect } from 'react-redux';
import { debounce } from 'lodash';

import { Typography } from 'rmwc';
import { Text } from '../../components/Text';
import { SelectControl } from '../../components/controls/SelectControl';

import { runFullSimulation } from '../../actions/simulationActions';

export class FinancialShockSidebar extends Component {
  constructor(props) {
    super(props);
    this.state = { financial_shock: 'recession' };
    this.runSim();
  }

  runSim = () => {
    // this.props.runFullSimulation('DASHBOARD_', {
    //   financial_shock: this.state.financial_shock,
    // });
  };

  onChange = evt => {
    this.setState({ financial_shock: evt.target.value }, this.runSim);
  };

  render() {
    return (
      <div className="hrbr-form">
        <SelectControl
          label="Financial Shock"
          value={this.state.financial_shock}
          spec={{
            options: ['recession', 'rising_rates', 'bull'],
            option_data: {
              recession: { label: 'Recession' },
              rising_rates: { label: 'Rising Rates' },
              bull: { label: 'Bull' },
            },
          }}
          onChange={evt => this.onChange(evt)}
        />
      </div>
    );
  }
}

const mapDispatchToProps = {
  runFullSimulation,
};

export default connect(null, mapDispatchToProps)(FinancialShockSidebar);
